var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppPreLoader',{attrs:{"show-pre-loader":true,"loading-message":_vm.$t('landing.loggingOut')}})}
var staticRenderFns = []

export { render, staticRenderFns }